/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ticked-sale': {
    width: 28,
    height: 17,
    viewBox: '0 0 28 17',
    data: '<path pid="0" _fill="#78c076" d="M26.906 6.388c-1.206 0-2.187.952-2.187 2.122s.981 2.123 2.187 2.123H28V17H0v-6.367h1.094c1.206 0 2.187-.952 2.187-2.123 0-1.17-.981-2.122-2.187-2.122H0V.021h.028L.026.016.06 0h5.128l-.046.02h16.281L21.412 0h3.495c.1.013.2.02.304.02H28v6.368zm-1.094-4.245H2.187V4.4c1.885.472 3.282 2.136 3.282 4.11 0 1.975-1.397 3.639-3.282 4.11v2.258h23.625V12.62c-1.884-.473-3.28-2.136-3.28-4.11 0-1.975 1.396-3.639 3.28-4.111zM9.4 7c.773 0 1.4.672 1.4 1.5S10.173 10 9.4 10C8.627 10 8 9.328 8 8.5S8.627 7 9.4 7zM14 7c.773 0 1.4.672 1.4 1.5S14.773 10 14 10c-.773 0-1.4-.672-1.4-1.5S13.227 7 14 7zm4.6 0c.773 0 1.4.672 1.4 1.5s-.627 1.5-1.4 1.5c-.773 0-1.4-.672-1.4-1.5S17.827 7 18.6 7z"/>'
  }
})
